import { GenericStateMeta } from "store/common";

export interface PayByTextData {
  id?: number; // enrollmentFeature.id
  conversationEnrollmentId?: number;
  accountInformationId: number;
  phoneNumber: string;
  status: number;
  paymentMethodId: number;
  paymentAmountType: number;
  paymentAmount?: number;
}

export interface PayByTextState {
  meta: GenericStateMeta;
  byAccount: Record<number, PayByTextData>;
}

export const defaultPayByTextData: PayByTextData = {
  id: 0,
  accountInformationId: 0,
  phoneNumber: "",
  status: 0,
  paymentMethodId: 0,
  paymentAmountType: 0,
  paymentAmount: undefined,
};

export interface PayByTextApiResponse {
  enrollmentFeatureStatus: number;
  enrollmentFeature: {
    accountInformationId: number;
    paymentMethodId: number;
    paymentAmount: number;
    featureKey: number;
    acknowledgementTimestamp: string | null;
    conversationEnrollmentId: number;
    conversationEnrollment: {
      userId: number;
      phoneNumber: string;
      clientId: number;
    };
    id: number;
    created: string;
    createdBy: string | null;
    modified: string | null;
    modifiedBy: string | null;
    deleted: string | null;
    deletedBy: string | null;
  };
}
